import { Box } from '@wix/design-system';
import React from 'react';
import { TldPromotionSkeleton } from './TldPromotion/TldPromotionSkeleton';
export const TldPromotionsSkeleton = _ref => {
  let _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 6 : _ref$limit;
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    display: "block",
    borderRadius: "12px",
    border: "1px solid #DEDEDE",
    padding: "38px 0"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(max(250px, calc(25% - 16px)), 1fr))",
    gap: "50px 16px",
    width: "100%",
    position: "relative"
  }, Array.from({
    length: limit
  }).map((_, index) => {
    return /*#__PURE__*/React.createElement(TldPromotionSkeleton, {
      key: index,
      index: index
    });
  })));
};
//# sourceMappingURL=TldPromotionsSkeleton.js.map